<template>
  <b-table
    striped
    hover
    borderless
    responsive
    sticky-column
    :items="models"
  >
  </b-table>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'settings/apiTest',
      attribute: 'models'
    }
  },

  computed: {
    models () {
      return this.$store.getters[`${this.modelName}/getAttr`](this.attribute)
    }
  }
}
</script>
